// Import logger first to disable console in production - MUST be before any other imports
import "./utils/logger";

import * as ReactDOM from "react-dom/client";

import App from "./app/app";
import { Provider } from "react-redux";
import { store } from "./store/index";
import "./scss/theme.scss";
import { initGtm } from "./utils/analytics";

// Initialize GTM container if configured via env
initGtm();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
